import React, { useCallback, useContext } from 'react'

import { FlightSearchCard } from './FlightSearchCard'
import FlightSearchTileContent from './FlightSearchTileContent'
import FlightWithAirportsTile from './FlightWithAirportsTile'
import { ItemCardVariant } from '../ItemCard/ItemCard'

import { isOneWayFlight } from 'lib/flights/flightUtils'
import TripContext from 'tripPlanner/contexts/TripContext'
import useImmersiveModeHandlers from 'tripPlanner/hooks/useImmersiveModeHandlers'
import { LEFlightItem } from 'tripPlanner/types/tripItem'
import { itemSectionId } from 'tripPlanner/utils/itemSection'

export interface Props {
  item: LEFlightItem
  tripNameLabel?: React.ReactNode
  variant: ItemCardVariant
}

export default function FlightSearchTile({
  item,
  tripNameLabel,
  variant,
}: Props) {
  const { setImmersiveMode } = useImmersiveModeHandlers()

  const onFlightSearchClick = useCallback(() => {
    setImmersiveMode({
      sectionId: itemSectionId(item.id),
      tripId: item.tripId,
    })
  }, [item.id, item.tripId, setImmersiveMode])

  const tripContext = useContext(TripContext)
  const canEdit = tripContext?.permissions.canEdit ?? false

  if (
    (item.startDate && item.endDate) ||
    (isOneWayFlight(item.savedItemData.fareType) && item.startDate)
  ) {
    // Saved flight search have dates but no start/end time
    return (
      <FlightSearchCard
        target={canEdit ? undefined : '_blank'}
        data-testid="saved-flight-search-card"
      >
        <FlightSearchTileContent
          item={item}
          tripNameLabel={tripNameLabel}
          variant={variant}
          onFlightSearchClick={onFlightSearchClick}
        />
      </FlightSearchCard>
    )
  } else {
    // copied flight items have no dates
    return <FlightWithAirportsTile item={item} />
  }
}
